import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './EnvelopeContact.module.css';
import { motion as m } from 'motion/react'


function EnvelopeContact() {

    const flapTopMotion = {
        rest: {
            d: "M12 16L21.9728 25.1418C23.1198 26.1931 24.8802 26.1931 26.0272 25.1418L36 16",
            fillOpacity: 0,
            transition: { duration: .2 }
        },
        hover: {
            d: "M12 16L22.0794 7.60046C23.192 6.67335 24.808 6.67335 25.9206 7.60046L36 16",
            fillOpacity: 0.6,
            transition: { duration: .1 }
        },
        tap: {
            d: "M12 16L22.0794 7.60046C23.192 6.67335 24.808 6.67335 25.9206 7.60046L36 16",
            fillOpacity: 0.8,
            transition: { duration: .1 }
        }
    };

    const flapBottomMotion = {
        rest: {
            d: "M26.5781 24.8359C26.7608 24.7104 27.0047 24.7197 27.1768 24.8594L35.4961 31.6113C35.8617 31.9081 35.6515 32.5 35.1807 32.5H12.8193C12.3485 32.5 12.1383 31.9081 12.5039 31.6113L20.8242 24.8594C20.9962 24.7199 21.2393 24.7097 21.4219 24.835L22.0186 25.2451C23.2127 26.0653 24.7895 26.0647 25.9834 25.2441L26.5781 24.8359Z",
            transition: { duration: 0.1 }
        },
        hover: {
            d: "M22.585 23.5791C23.4379 22.9933 24.5642 22.993 25.417 23.5791L26.6055 24.3965L35.4961 31.6113C35.8617 31.9081 35.6515 32.5 35.1807 32.5H12.8193C12.3485 32.5 12.1383 31.9081 12.5039 31.6113L21.3936 24.3965L22.585 23.5791Z",
            transition: { duration: 0 }
        },
        tap: {
            d: "M22.585 23.5791C23.4379 22.9933 24.5642 22.993 25.417 23.5791L26.6055 24.3965L35.4961 31.6113C35.8617 31.9081 35.6515 32.5 35.1807 32.5H12.8193C12.3485 32.5 12.1383 31.9081 12.5039 31.6113L21.3936 24.3965L22.585 23.5791Z",
            transition: { duration: 0 }
        }
    };

    const mailPaperMotion = {
        rest: {
            fillOpacity: 0,
            d: "M32.0273 19.4847C32.091 19.4529 32.1531 19.4641 32.1982 19.4974C32.2584 19.5418 32.2891 19.6265 32.2549 19.7005C32.2464 19.7188 32.2337 19.737 32.2168 19.7533L27.1592 24.6273L27.0771 24.5628C27.0242 24.5213 26.9674 24.4845 26.9072 24.4544L25.3779 23.6898C24.5117 23.2568 23.4898 23.2692 22.6338 23.722L21.4854 24.3294C21.428 24.3598 21.3737 24.3959 21.3232 24.4369L21.165 24.5648L16.3047 20.221L16.3828 20.2835C16.4363 20.3224 16.4932 20.3558 16.5527 20.3832C16.7022 20.4518 16.8681 20.4838 17.0352 20.473L31.9639 19.5023C31.9859 19.5009 32.0076 19.4946 32.0273 19.4847Z",
            transition: {
                duration: 0.06
            }
        },
        hover: {
            fillOpacity: 1,
            d: "M27.1592 24.626L27.0771 24.5615C27.0242 24.52 26.9664 24.4842 26.9062 24.4541L25.3779 23.6895C24.5115 23.2563 23.489 23.2686 22.6328 23.7217L21.4854 24.3291C21.4278 24.3595 21.3728 24.3955 21.3223 24.4365L21.1641 24.5645L17.7227 21.4893L17.792 21.5449C17.9575 21.668 18.1576 21.7373 18.3652 21.7422L29.1143 21.9912C29.2068 21.9933 29.2984 21.9817 29.3867 21.959C29.5335 21.9211 29.6712 21.8502 29.7881 21.75L32.9971 19L27.1592 24.626Z",
            transition: {
                duration: .2
            }
        },
        tap: {
            fillOpacity: 1,
            d: "M32.0273 19.4847C32.091 19.4529 32.1531 19.4641 32.1982 19.4974C32.2584 19.5418 32.2891 19.6265 32.2549 19.7005C32.2464 19.7188 32.2337 19.737 32.2168 19.7533L27.1592 24.6273L27.0771 24.5628C27.0242 24.5213 26.9674 24.4845 26.9072 24.4544L25.3779 23.6898C24.5117 23.2568 23.4898 23.2692 22.6338 23.722L21.4854 24.3294C21.428 24.3598 21.3737 24.3959 21.3232 24.4369L21.165 24.5648L16.3047 20.221L16.3828 20.2835C16.4363 20.3224 16.4932 20.3558 16.5527 20.3832C16.7022 20.4518 16.8681 20.4838 17.0352 20.473L31.9639 19.5023C31.9859 19.5009 32.0076 19.4946 32.0273 19.4847Z",
            transition: {
                duration: .4
            }
        }
    }



    const mainBodyMotion = {
        rest: {
            fillOpacity: "0.3",
            transition: {
                duration: .2
            }
        },
        hover: {
            fillOpacity: "0.6",
            transition: {
                duration: .2
            }
        },
        tap: {
            fillOpacity: "0.8",
            transition: {
                duration: .8
            }
        }
    }




    return (

        <>
            <m.a title="Send an email to design@jlliew.com" href="mailto:design@jlliew.com" tabIndex="0"
                className={styles.contactEnvelope} initial="rest" whileHover="hover" whileTap="tap" whileFocus="tap" animate="rest">
                <m.svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <m.rect id="mainBody" variants={mainBodyMotion}
                        fill="white" fill-opacity="0.3" stroke="white" stroke-width="1"
                        x="11.5" y="15.5" width="25" height="17" rx="0.5" />
                    <m.path id="flapBottom" variants={flapBottomMotion}
                        d="M26.5781 24.8359C26.7608 24.7104 27.0047 24.7197 27.1768 24.8594L35.4961 31.6113C35.8617 31.9081 35.6515 32.5 35.1807 32.5H12.8193C12.3485 32.5 12.1383 31.9081 12.5039 31.6113L20.8242 24.8594C20.9962 24.7199 21.2393 24.7097 21.4219 24.835L22.0186 25.2451C23.2127 26.0653 24.7895 26.0647 25.9834 25.2441L26.5781 24.8359Z"
                        fill="none" stroke="white"
                    />
                    <m.path id="mailPaper" variants={mailPaperMotion}
                        d="M31.7236 19.4844C31.8719 19.4105 32.0099 19.57 31.9512 19.6992L31.9502 19.7002C31.9417 19.7184 31.929 19.7367 31.9121 19.7529L26.7793 24.7002C26.5627 24.6548 26.3327 24.6803 26.127 24.7832L25.1992 25.2471C24.2642 25.7146 23.1529 25.6617 22.2666 25.1074L21.7012 24.7539C21.4673 24.6076 21.19 24.5683 20.9336 24.6309L16 20.2207L16.0781 20.2832C16.1319 20.3222 16.1892 20.3553 16.249 20.3828C16.309 20.4103 16.3713 20.432 16.4355 20.4473C16.5312 20.47 16.6306 20.4791 16.7305 20.4727L31.6602 19.502C31.6822 19.5005 31.7039 19.4943 31.7236 19.4844Z"
                        fill="white" fill-opacity="0" />
                    <path id="flapSides" d="M36 16L27 24.5M12 16L21 24.5" stroke="white" stroke-width="0.8" />
                    <m.path id="flapTop" variants={flapTopMotion}
                        d="M12 16L21.9728 25.1418C23.1198 26.1931 24.8802 26.1931 26.0272 25.1418L36 16"
                        stroke="white" stroke-width="1" fill="white" fill-opacity="0"
                    />
                </m.svg>
                <p className={styles.contactEnvelopeText}>design@jlliew.com</p>
            </m.a>
        </>


    );
}

export default EnvelopeContact;
